<div class="checkboxes-group"
    [ngClass]="{'checkboxes-group--with-check-all': checkAllButtonVisible}">

  <div *ngIf="checkAllButtonVisible"
       class="checkboxes-group__check-all">
    <mat-checkbox [checked]="allChecked"
                  (change)="onCheckAllChange($event)"
                  (click)="onCheckAllClick()">
      {{ config.checkAllLabel | translate }}
    </mat-checkbox>
  </div>

  <div class="checkboxes-group__checkboxes">
    <div *ngFor="let fieldKey of fieldKeys; let i = index"
         class="checkboxes-group__checkbox">
      <app-checkbox [bean]="bean"
                    [index]="i"
                    [errorsMap]="formFactoryService.errorsMap"
                    [control]="formGroup.controls[fieldKey]"
                    [fieldConfig]="formFactoryService.fieldConfig(fieldKey, formConfig)"
                    [context]="formConfig.formKey"
                    (changeEvent)="onCheckboxChange($event)"
                    (interactiveClick)="onCheckboxInteractiveClick($event)"
      >
      </app-checkbox>
    </div>
  </div>
</div>
